/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";

// reducers
import { selectCountry } from 'hyc-store/reducers/countries/countriesReducer';

// components
import { BoxesTable } from "./boxes-table";
import { CustomersFilterBarTimed } from "shared/components/bulma/customers-filter-bar";

import * as helper from "./helper";

const DEFAULT_TABS = ['Late Boxes', 'History'];
const QUERY_LIMIT_CHARS = 2;

const LateBoxes = ({ location }) => {
    const [lateBoxes, setLateBoxes] = useState([]);
    const [results, setResults] = useState([]);
    const [dirty, setDirty] = useState(false);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState(DEFAULT_TABS[0]);

    const country = useSelector(selectCountry);
    const history = useHistory();

    const handleTabChange = (tab) => {
        setDirty(false);
        setLoading(true);
        setActiveTab(tab);
        const pathname = location.pathname;
        history.push({
            pathname,
            search: `?tab=${tab.toLowerCase()}`
        });
        setLoading(false);
    };
    const onlyCharged = []
    for (const box of lateBoxes) {
        if (box.is_charged || box.exempted) {
            onlyCharged.push(box);
        };
    };

    const displayedData = activeTab === 'Late Boxes' ? lateBoxes : onlyCharged;

    const handleFilterChange = ({ event, type }) => {
        if (!event?.target) {
            return;
        };

        const { value } = event.target;
        const { select, input } = value;

        const query = input.trim();
        if (select && query && query.length >= QUERY_LIMIT_CHARS) {
            searchCustomers({ field: select, query })
        } else if (query === '') {
            setDirty(false);
            setResults([]);
        };
    };

    const searchCustomers = async ({ field, query }) => {
        setLoading(true);
        setDirty(true);
        const results = await helper.getBoxesByUsers(activeTab, field, query, country);
        setResults(results);
        setLoading(false);
    };

    useEffect(() => {
        const tab = new URLSearchParams(location.search).get('tab');
        if (tab) {
            const activeTab = DEFAULT_TABS.find((t) => t.toLowerCase() === tab.toLowerCase());
            setActiveTab(activeTab);
        };

        const getData = async () => {
            const lateBoxes = await helper.getProducts(country);
            setLateBoxes(lateBoxes);
            setLoading(false);
        };

        getData();

    }, [country, location.search]);

    return (
        <div className="container">
            <nav className="level">
                <div className="level-item">
                    <div>
                        <h1 className="title">Late Boxes</h1>
                        <h2 className="heading is-2">Customers kept these boxes longer than expected, at least 2 weeks.</h2>
                    </div>
                </div>
                <div className="level-item has-text-centered">
                    <div className="level-right">
                        <div className="tabs is-large">
                            <ul>
                                {(DEFAULT_TABS.map((tab) => (
                                    <li key={tab} className={tab === activeTab ? 'is-active' : ''}>
                                        <a onClick={() => handleTabChange(tab)}>{tab}</a>
                                    </li>
                                )))}
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
            <div className="columns">
                <div className="column is-4">
                    <CustomersFilterBarTimed timer="500" onChange={(event) => handleFilterChange({ event, type: 'customers' })} />
                </div>
                <div className="column is-4"></div>
            </div>
            {loading && (
                <progress className="progress is-large is-primary" max="100">15%</progress>
            )}
            {!loading && (
                <BoxesTable data={dirty ? results : displayedData} />
            )}
        </div>
    );
}

export { LateBoxes };
